export const tema = {
  text: "#E1E1E6",
  card: "#202024;",
  data: "#F7DD43",
  borda: "#338AF3",
  linha: "#323238",
};
